import React from 'react';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import { makeStyles } from '@material-ui/styles';
import Radio from '@material-ui/core/Radio';
import D3Tooltip from "../D3Charts/D3Tooltip";
import clsx from 'clsx';
import { useTranslation } from 'react-i18next';

const useStyles = makeStyles((theme) => ({
    root: {
        // color: theme.palette.primary.main,
        marginBottom: theme.spacing(1),
        marginTop: theme.spacing(1),
        border: `2px solid ${theme.palette.white}`
    },
    root1: {
        color: theme.palette.primary.main,
        marginBottom: theme.spacing(1),
        marginTop: theme.spacing(1),
    },
    chartDivideLine: {
        borderLeft: `2px solid ${theme.palette.white}`
    },
    value1Color:
    {
        color: theme.palette?.importtable?.cherryRed,
        fontSize: theme.spacing(3.75)
    },
    value2Color:
    {
        color: theme.palette?.importtable?.darkgeryishRed,
        fontSize: theme.spacing(3.75)
    },
    radioDiv: {
        marginTop: theme.spacing(1),
        display: 'flex',
        justifyContent: 'center',
        textAlign: "center"
    },
    radioDiv1: {
        marginTop: theme.spacing(1),
        display: 'flex',
        justifyContent: 'center',
        textAlign: 'right',
    },
    link: {
        cursor: 'pointer',
        textDecoration: 'underline',
        letterSpacing: '1px',
        padding: theme.spacing(.4),
        '&:hover': {
            color: theme.palette?.link?.hover
        }
    },
}));

export const SubheaderPattern1 = ({
    value1,
    value2,
    value3,
    text1,
    text2,
    text3,
    ...rest
}) => {
    const classes = useStyles();
    const isHyperlink = typeof rest?.setDetails === "function";
    const { t } = useTranslation();

    return (
        <Grid container spacing={2} className={classes.root} justifyContent="center" alignItems="center" >
            <Grid item spacing={2} display="flex" flexDirection="row" alignItems="center">
                <D3Tooltip placement="top"
                    title={<div
                        className={clsx(isHyperlink ? classes.link : {})}
                        onClick={() => { isHyperlink && rest.setDetails({ ...rest, stateKey: rest.stateKey1 }) }}
                    >
                        {`${t(text1)}: ${value1}`}
                    </div>}>
                    <Box display="flex" flexDirection="column" alignItems="center" data-testid={text1}>
                        <Typography variant="body1">{value1}</Typography>
                        <Typography variant="body1">{t(text1)}</Typography>
                    </Box>
                </D3Tooltip>
            </Grid>
            <Grid item spacing={2} display="flex" flexDirection="row" alignItems="center" className={classes.chartDivideLine}>

                <D3Tooltip placement="top"
                    title={<div
                        className={clsx(isHyperlink ? classes.link : {})}
                        onClick={() => { isHyperlink && rest.setDetails({ ...rest, stateKey: rest.stateKey2 }) }}
                    >
                        {`${t(text2)}: ${value2}`}
                    </div>}>
                    <Box display="flex" flexDirection="column" alignItems="center" data-testid={text2}>
                        <Typography variant="body1">{t(text2)}</Typography>
                        <Typography variant="body1">{value2}</Typography>
                    </Box>
                </D3Tooltip>

            </Grid >
            <Grid item spacing={2} display="flex" flexDirection="row" alignItems="center">
                <D3Tooltip placement="top"
                    title={<div
                        className={clsx(isHyperlink ? classes.link : {})}
                        onClick={() => { isHyperlink && rest.setDetails({ ...rest, stateKey: rest.stateKey3 }) }}
                    >
                        {`${t(text3)}: ${value3}`}
                    </div>}>
                    <Box display="flex" flexDirection="column" alignItems="center" data-testid={text3}>
                        <Typography variant="body1">{t(text3)}</Typography>
                        <Typography variant="body1">{value3}</Typography>
                    </Box>
                </D3Tooltip>
            </Grid >
        </Grid >
    );
};

export const SubheaderPattern2 = ({
    text1,
    text2,
    text3,
    value1,
    value2,
    value3,
    ...rest
}) => {
    const classes = useStyles();
    const isHyperlink = typeof rest?.setDetails === "function";
    const { t } = useTranslation();

    return (
        <Box display="flex" justifyContent="center" textAlign={"center"} mt={1} border={1} className={classes.root1}>
            <Grid item xs={12} sm={12} md={12} lg={12} xl={12} >
                <Grid >
                    <D3Tooltip placement="top"
                        title={<div
                            className={clsx(isHyperlink ? classes.link : {})}
                            onClick={() => { isHyperlink && rest.setDetails({ ...rest, stateKey: rest.stateKey1 }) }}
                        >
                            {`${t(text1)}: ${value1}`}
                        </div>}>
                        <Typography component='p' data-testid={text1}>
                            <Typography variant="body1" >{t(text1)}</Typography>
                            <Typography variant="body1" className={value3 !== undefined ? classes.value2Color : classes.value1Color}>{value1}</Typography>
                        </Typography>
                    </D3Tooltip>
                </Grid>
            </Grid>
            <Grid item xs={12} sm={12} md={12} lg={12} xl={12} display="flex" justifyContent="center" className={classes.chartDivideLine}>
                <Grid>
                    <D3Tooltip placement="top"
                        title={<div
                            className={clsx(isHyperlink ? classes.link : {})}
                            onClick={() => { isHyperlink && rest.setDetails({ ...rest, stateKey: rest.stateKey2 }) }}
                        >
                            {`${t(text2)}: ${value2}`}
                        </div>}>
                        <Typography component='p' data-testid={text2}>
                            <Typography variant="body1">{t(text2)}</Typography>
                            <Typography variant="body1" className={value2 !== undefined ? classes.value2Color : classes.value1Color} >{value2}</Typography>
                        </Typography>
                    </D3Tooltip>
                </Grid >
            </Grid>
            {value3 !== undefined && <Grid item xs={12} sm={12} md={12} lg={12} xl={12} display="flex" justifyContent="center" className={classes.chartDivideLine}>
                <Grid>
                    <D3Tooltip placement="top"
                        title={<div
                            className={clsx(isHyperlink ? classes.link : {})}
                            onClick={() => { isHyperlink && rest.setDetails({ ...rest, stateKey: rest.stateKey3 }) }}
                        >
                            {`${t(text3)}: ${value3}`}
                        </div>}>
                        <Typography component='p' data-testid={text3}>
                            <Typography variant="body1">{t(text3)}</Typography>
                            <Typography variant="body1" className={value3 !== undefined ? classes.value2Color : classes.value1Color} >{value3}</Typography>
                        </Typography>
                    </D3Tooltip>
                </Grid >
            </Grid>}
        </Box>
    );
};

export const SubheaderPattern3 = ({
    text1,
    text2,
    text3,
    handleChange,
    selectedValue,
    ...rest
}) => {
    const classes = useStyles();
    const { t } = useTranslation();
    return (
        <Grid container >
            <Grid item xs={12} sm={12} md={12} lg={12} xl={12} className={classes.radioDiv}>
                <Typography variant="h6">
                    <Radio
                        checked={selectedValue === rest.radioKey}
                        onClick={() => handleChange(rest.radioKey)}
                        inputProps={{ 'data-testid': rest.radioKey }}
                    />
                    {t(text1)}
                    <Radio
                        checked={selectedValue === rest.radioKey1}
                        onClick={() => handleChange(rest.radioKey1)}
                        inputProps={{ 'data-testid': rest.radioKey1 }}
                    />
                    {t(text2)}
                    {text3 && <>
                        <Radio
                            checked={selectedValue === rest.radioKey2}
                            onClick={() => handleChange(rest.radioKey2)}
                            inputProps={{ 'data-testid': rest.radioKey2 }}
                        />
                        {t(text3)}
                    </>}
                </Typography>
            </Grid>
        </Grid>

    );
};

export const SubheaderPattern4 = ({
    text1,
    text2,
    text3,
    text4,
    text5,
    text6,
    text7,
    handleChange,
    selectedValue,
    handleRadioValue,
    selectedValue1,
    ...rest
}) => {
    const classes = useStyles();
    const { t } = useTranslation();
    return (
        <Grid container alignItems="center" style={{ display: "flex", justifyContent: "space-between" }}>
            <Grid item xs="auto" className={classes.radioDiv}>
                <Typography variant="h6">
                    <Radio
                        checked={selectedValue === rest.radioKey}
                        onClick={() => handleChange(rest.radioKey)}
                        inputProps={{ 'data-testid': rest.radioKey }}
                    />
                    {t(text1)}
                    <Radio
                        checked={selectedValue === rest.radioKey1}
                        onClick={() => handleChange(rest.radioKey1)}
                        inputProps={{ 'data-testid': rest.radioKey1 }}
                    />
                    {t(text2)}
                    <Radio
                        checked={selectedValue === rest.radioKey2}
                        onClick={() => handleChange(rest.radioKey2)}
                        inputProps={{ 'data-testid': rest.radioKey2 }}
                    />
                    {t(text3)}
                    {text4 && <>
                        <Radio
                            checked={selectedValue === rest.radioKey3}
                            onClick={() => handleChange(rest.radioKey3)}
                            inputProps={{ 'data-testid': rest.radioKey3 }}
                        />
                        {t(text4)}
                    </>}
                </Typography>
            </Grid>
            <Grid item xs="auto" className={classes.radioDiv1}>
                <Typography variant="h6">
                    <Radio
                        checked={selectedValue1 === rest.radioKey4}
                        onClick={() => handleRadioValue(rest.radioKey4)}
                        inputProps={{ 'data-testid': rest.radioKey4 }}
                    />
                    {t(text5)}
                    <Radio
                        checked={selectedValue1 === rest.radioKey5}
                        onClick={() => handleRadioValue(rest.radioKey5)}
                        inputProps={{ 'data-testid': rest.radioKey5 }}
                    />
                    {t(text6)}
                    {text7 && <>
                        <Radio
                            checked={selectedValue1 === rest.radioKey6}
                            onClick={() => handleRadioValue(rest.radioKey6)}
                            inputProps={{ 'data-testid': rest.radioKey6 }}
                        />
                        {t(text7)}
                    </>}
                </Typography>
            </Grid>
        </Grid>

    );
};